import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { StatCardData } from './types';

interface DashboardStatsProps {
    loading: boolean;
    cards: StatCardData[];
}

const DashboardStats: React.FC<DashboardStatsProps> = ({ loading, cards }) => {
    if (loading) {
        return (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="bg-white p-6 rounded-xl shadow-sm border animate-pulse">
                        <div className="flex items-center justify-between">
                            <div className="space-y-3 flex-1">
                                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                <div className="h-8 bg-gray-200 rounded w-1/2"></div>
                                <div className="h-3 bg-gray-200 rounded w-1/4"></div>
                            </div>
                            <div className="h-12 w-12 bg-gray-200 rounded-lg"></div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {cards.map((card) => {
                const IconComponent = card.icon;
                return (
                    <Link
                        key={card.name}
                        to={card.link}
                        className="bg-white p-6 rounded-xl shadow-sm border hover:shadow-md transition-all duration-200 hover:scale-105 group"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex-1">
                                <p className="text-sm font-medium text-gray-600 mb-1">
                                    {card.name}
                                </p>
                                <p className="text-3xl font-bold text-gray-900 mb-2">
                                    {card.value}
                                </p>
                                <div className="flex items-center">
                                    <TrendingUp
                                        className={`h-4 w-4 mr-1 ${card.changeType === 'positive' ? 'text-green-600' : 'text-red-600'
                                            }`}
                                    />
                                    <span
                                        className={`text-sm font-medium ${card.changeType === 'positive' ? 'text-green-600' : 'text-red-600'
                                            }`}
                                    >
                                        {card.change}
                                    </span>
                                    <span className="text-sm text-gray-500 ml-1">güncel</span>
                                </div>
                            </div>
                            <div className={`p-3 ${card.bgColor} rounded-lg group-hover:scale-110 transition-transform duration-200`}>
                                <IconComponent className={`h-6 w-6 ${card.textColor}`} />
                            </div>
                        </div>
                    </Link>
                );
            })}
        </div>
    );
};

export default DashboardStats;
